'use client';

import React from 'react';
import GCaptcha from 'react-google-recaptcha';

import useTheme from 'hooks/common/useTheme';

import useAppSelector from 'hooks/redux/useAppSelector';

import { GOOGLE_CAPTCHA_KEY_2 } from 'config';

import { IGoogleCaptchaProps } from './GoogleCaptcha.types';

const GoogleCaptcha = ({ ...props }: IGoogleCaptchaProps) => {
  const { theme } = useTheme();
  const { language } = useAppSelector(state => state.language);

  return <GCaptcha sitekey={GOOGLE_CAPTCHA_KEY_2} hl={language} theme={theme} {...props} />;
};

export default GoogleCaptcha;
